import { createContext } from "react";

import { TreatmentAndManagementSidePanelHelper } from "./TreatmentAndManagementSidePanelHelper.ts";

export const TreatmentAndManagementSidePanelContext =
  createContext<TreatmentAndManagementSidePanelHelper>(
    {} as TreatmentAndManagementSidePanelHelper
  );
